import React from "react"
import { Suspense } from "react"

const RaydiumDataView = React.lazy(() => import('../RaydiumDataView'))
const RaydiumPools = React.lazy(() => import('../RaydiumPools/RaydiumPools'))

export default function RaydiumRobot() {


    
    return (
        <>
            <Suspense fallback='loading ...' >
                <RaydiumPools />
            </Suspense >
            <Suspense fallback='loading ...' >
                <RaydiumDataView />
            </Suspense >
        </>
    )
}